<template>
  <ion-page>
    <ion-content class="home-page">
      <div class="main_content_div">
        <div class="user_div">
          <h2></h2>
        </div>
        <div class="top-radius" />
        <div class="content_div">
          <div class="card-heading ion-padding">
            <ion-card style="margin: 0; border-radius: 18px">
              <ion-card-header style="padding: 10px" class="flex-between">
                <ion-card-subtitle
                  class="ion-text-capitalize"
                  style="margin: 0; font-size: 0.8rem"
                >
                  {{ ConvertFullDate(new Date()) }}
                </ion-card-subtitle>
              </ion-card-header>
              <ion-card-content>
                <br />
                <center>
                  <h1>Hallo Selamat datang Staf, {{ userName }}!</h1>
                </center>
                <div class="absen-buttons">
                  <ion-button
                    :color="isAbsenMasuk ? 'primary' : 'danger'"
                    @click="handleAbsen"
                    >{{ absenLabel }}</ion-button
                  >
                  <ion-button color="secondary" @click="scanQRCode"
                    >Scan QR Code</ion-button
                  >
                </div>
              </ion-card-content>
            </ion-card>
          </div>
          <br />
          <ion-col>Menu</ion-col>
          <ion-grid>
            <ion-row>
              <ion-col size="6">
                <div
                  class="menu-item"
                  @click.prevent="toNavigate('laporanizinPetugas')"
                  style="
                    background-color: #c80036;
                    border-radius: 8px;
                    padding: 10px;
                  "
                >
                  <ion-icon
                    :icon="informationCircleOutline"
                    size="large"
                    style="color: #fff"
                  ></ion-icon>
                  <p style="color: #fff">Ajukan Izin</p>
                </div>
              </ion-col>
              <ion-col size="6">
                <div
                  class="menu-item"
                  @click.prevent="toNavigate('laporankehadiranPetugas')"
                  style="
                    background-color: #c80036;
                    border-radius: 8px;
                    padding: 10px;
                  "
                >
                  <ion-icon
                    :icon="clipboardOutline"
                    size="large"
                    style="color: #fff"
                  ></ion-icon>
                  <p style="color: #fff">Lap Kehadiran</p>
                </div>
              </ion-col>
              <ion-col size="6">
                <div
                  class="menu-item"
                  @click.prevent="toNavigate('halamanpenggunaPetugas')"
                  style="
                    background-color: #c80036;
                    border-radius: 8px;
                    padding: 10px;
                  "
                >
                  <ion-icon
                    :icon="peopleOutline"
                    size="large"
                    style="color: #fff"
                  ></ion-icon>
                  <p style="color: #fff">Pengguna</p>
                </div>
              </ion-col>
              <ion-col size="6">
                <div
                  class="menu-item"
                  @click.prevent="toNavigate('halamansettingPetugas')"
                  style="
                    background-color: #c80036;
                    border-radius: 8px;
                    padding: 10px;
                  "
                >
                  <ion-icon
                    :icon="settingsOutline"
                    size="large"
                    style="color: #fff"
                  ></ion-icon>
                  <p style="color: #fff">Checkup</p>
                </div>
              </ion-col>
            </ion-row>
          </ion-grid>

          <br />
          <ion-col>Laporan Absen Mingguan</ion-col>
          <ion-grid>
            <ion-row>
              <ion-col>
                <ion-list>
                  <ion-item
                    v-for="record in weeklyAttendanceRecords"
                    :key="record.date"
                  >
                    <ion-label>
                      <h2>{{ formatDayDate(record.date) }}</h2>
                      <p>
                        Masuk:
                        <ion-badge
                          :color="isLate(record.masuk) ? 'danger' : 'success'"
                        >
                          {{
                            record.masuk
                              ? record.masuk.toDate().toLocaleString()
                              : "Belum absen masuk"
                          }}
                        </ion-badge>
                      </p>
                      <p>
                        Keluar:
                        {{
                          record.keluar
                            ? record.keluar.toDate().toLocaleString()
                            : "Belum absen keluar"
                        }}
                      </p>
                      <p v-if="isLate(record.masuk)">
                        Terlambat:
                        <ion-badge
                          :color="isLate(record.masuk) ? 'danger' : 'success'"
                        >
                          {{ calculateLateness(record.masuk) }}
                        </ion-badge>
                      </p>
                      <p v-else>
                        <ion-badge color="success">Tepat Waktu</ion-badge>
                      </p>
                    </ion-label>
                  </ion-item>
                </ion-list>
              </ion-col>
            </ion-row>
          </ion-grid>
        </div>
      </div>
      <ion-toast
        :is-open="toast.isOpen"
        :message="toast.message"
        :duration="toast.duration"
        :color="toast.color"
        @did-dismiss="toast.isOpen = false"
      ></ion-toast>
    </ion-content>
  </ion-page>
</template>

<script setup>
import { ref, onMounted } from "vue";
import {
  IonPage,
  IonContent,
  IonCard,
  IonCardHeader,
  IonCardSubtitle,
  IonCardContent,
  IonGrid,
  IonRow,
  IonCol,
  IonButton,
  IonList,
  IonItem,
  IonLabel,
  IonToast,
} from "@ionic/vue";
import {
  informationCircleOutline,
  clipboardOutline,
  peopleOutline,
  settingsOutline,
} from "ionicons/icons";

import { ConvertFullDate } from "../composables/composables";
import { useRouter } from "vue-router";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import {
  getFirestore,
  doc,
  getDoc,
  setDoc,
  updateDoc,
  serverTimestamp,
  collection,
  query,
  getDocs,
  orderBy,
} from "firebase/firestore";
import { firebaseApp } from "../views/firebase.js";

const router = useRouter();

const userName = ref("");
const userStatus = ref(""); // Add user status
const isAbsenMasuk = ref(true);
const absenLabel = ref("Absen Masuk");
const attendanceRecords = ref([]);
const weeklyAttendanceRecords = ref([]);
const toast = ref({
  isOpen: false,
  message: "",
  duration: 2000,
  color: "success",
});

const allowedCoordinates = ref(null); // Remove default coordinates

// Initialize Firebase
const auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp);

const fetchUserName = async (uid) => {
  try {
    const userDoc = await getDoc(doc(db, "users", uid));
    if (userDoc.exists()) {
      const userData = userDoc.data();
      userName.value = userData.fullName;
      userStatus.value = userData.status; // Fetch user status
    }
  } catch (error) {
    console.error("Error fetching user data:", error);
  }
};

const fetchCoordinates = async () => {
  try {
    const locationDoc = await getDoc(doc(db, "settings", "coordinates"));
    if (locationDoc.exists()) {
      allowedCoordinates.value = locationDoc.data();
    }
  } catch (error) {
    console.error("Error fetching coordinates:", error);
  }
};

const fetchAttendanceRecords = async (uid) => {
  const recordsRef = collection(db, "attendance", uid, "records");
  const q = query(recordsRef, orderBy("masuk", "desc"));
  try {
    const querySnapshot = await getDocs(q);
    attendanceRecords.value = querySnapshot.docs.map((doc) => ({
      date: doc.id,
      ...doc.data(),
    }));
    filterWeeklyRecords();
  } catch (error) {
    console.error("Error fetching attendance records:", error);
  }
};

const filterWeeklyRecords = () => {
  const now = new Date();
  const dayOfWeek = now.getDay();
  const startOfWeek = new Date(now);
  startOfWeek.setDate(now.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1));
  const endOfWeek = new Date(startOfWeek);
  endOfWeek.setDate(startOfWeek.getDate() + 6);

  weeklyAttendanceRecords.value = [];

  for (
    let date = new Date(startOfWeek);
    date <= now;
    date.setDate(date.getDate() + 1)
  ) {
    const formattedDate = date.toISOString().split("T")[0];
    const record = attendanceRecords.value.find(
      (record) => record.date === formattedDate
    );
    weeklyAttendanceRecords.value.push(
      record || { date: formattedDate, masuk: null, keluar: null }
    );
  }
};

const checkAbsenStatus = async (uid) => {
  const today = new Date().toISOString().split("T")[0];
  const recordRef = doc(db, "attendance", uid, "records", today);
  try {
    const docSnapshot = await getDoc(recordRef);
    if (docSnapshot.exists()) {
      if (docSnapshot.data().keluar) {
        isAbsenMasuk.value = true;
        absenLabel.value = "Absen Masuk";
      } else {
        isAbsenMasuk.value = false;
        absenLabel.value = "Absen Keluar";
      }
    } else {
      isAbsenMasuk.value = true;
      absenLabel.value = "Absen Masuk";
    }
  } catch (error) {
    console.error("Error checking absen status:", error);
  }
};

const absenMasuk = async () => {
  const user = auth.currentUser;
  if (user) {
    if (userStatus.value === "non-aktif") {
      showToast(
        "Status Anda non-aktif. Anda tidak dapat melakukan absensi.",
        "danger"
      );
      return;
    }
    const isWithinLocation = await checkGeolocation();
    if (!isWithinLocation) {
      showToast("Lokasi Anda tidak sesuai untuk absensi.", "danger");
      return;
    }
    const recordRef = doc(
      db,
      "attendance",
      user.uid,
      "records",
      new Date().toISOString().split("T")[0]
    );
    try {
      const docSnapshot = await getDoc(recordRef);
      if (docSnapshot.exists() && docSnapshot.data().masuk) {
        showToast("Anda sudah melakukan absensi masuk hari ini.", "danger");
        return;
      }
      await setDoc(
        recordRef,
        {
          masuk: serverTimestamp(),
        },
        { merge: true }
      );
      console.log("Absen masuk berhasil");
      showToast("Absen masuk berhasil", "success"); // Show success toast
      isAbsenMasuk.value = false;
      absenLabel.value = "Absen Keluar";
      fetchAttendanceRecords(user.uid);
    } catch (error) {
      console.error("Error setting masuk time:", error);
    }
  } else {
    console.log("User tidak terautentikasi");
  }
};

const absenKeluar = async () => {
  const user = auth.currentUser;
  if (user) {
    if (userStatus.value === "non-aktif") {
      showToast(
        "Status Anda non-aktif. Anda tidak dapat melakukan absensi.",
        "danger"
      );
      return;
    }
    const isWithinLocation = await checkGeolocation();
    if (!isWithinLocation) {
      showToast("Lokasi Anda tidak sesuai untuk absensi.", "danger");
      return;
    }
    const recordRef = doc(
      db,
      "attendance",
      user.uid,
      "records",
      new Date().toISOString().split("T")[0]
    );
    try {
      const docSnapshot = await getDoc(recordRef);
      if (!docSnapshot.exists() || docSnapshot.data().keluar) {
        showToast(
          "Anda belum melakukan absensi masuk atau sudah melakukan absensi keluar hari ini.",
          "danger"
        );
        return;
      }
      await updateDoc(recordRef, {
        keluar: serverTimestamp(),
      });
      console.log("Absen keluar berhasil");
      showToast("Absen keluar berhasil", "success"); // Show success toast
      isAbsenMasuk.value = true;
      absenLabel.value = "Absen Masuk";
      fetchAttendanceRecords(user.uid);
    } catch (error) {
      console.error("Error setting keluar time:", error);
    }
  } else {
    console.log("User tidak terautentikasi");
  }
};

const handleAbsen = async () => {
  if (isAbsenMasuk.value) {
    await absenMasuk();
  } else {
    await absenKeluar();
  }
};





const showToast = (message, color) => {
  toast.value = {
    isOpen: true,
    message,
    duration: 2000,
    color,
  };
};

const checkGeolocation = async () => {
  return new Promise((resolve) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const userLat = position.coords.latitude;
          const userLng = position.coords.longitude;
          const distance = calculateDistance(
            userLat,
            userLng,
            allowedCoordinates.value.latitude,
            allowedCoordinates.value.longitude
          );
          const allowedRadius = 0.1; // 100 meters
          resolve(distance <= allowedRadius);
        },
        (error) => {
          console.error("Error getting geolocation:", error);
          resolve(false);
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
      resolve(false);
    }
  });
};

const calculateDistance = (lat1, lng1, lat2, lng2) => {
  const toRad = (value) => (value * Math.PI) / 180;
  const R = 6371; // Radius of the Earth in km
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) *
      Math.cos(toRad(lat2)) *
      Math.sin(dLng / 2) *
      Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c;
  return distance;
};

const isLate = (timestamp) => {
  if (!timestamp) return false;
  const time = timestamp.toDate();
  const eightAM = new Date(time);
  eightAM.setHours(8, 0, 0, 0); // 8 AM
  return time > eightAM;
};

const calculateLateness = (timestamp) => {
  if (!timestamp) return "0 menit";
  const time = timestamp.toDate();
  const eightAM = new Date(time);
  eightAM.setHours(8, 0, 0, 0); // 8 AM
  const diff = time - eightAM; // Difference in milliseconds
  const hours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  return `${hours} jam ${minutes} menit`;
};

const formatDayDate = (dateString) => {
  const date = new Date(dateString);
  const days = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"];
  const day = days[date.getDay()];
  const formattedDate = date.toLocaleDateString("id-ID", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
  return `${day}, ${formattedDate}`;
};

onMounted(() => {
  onAuthStateChanged(auth, (user) => {
    if (user) {
      fetchUserName(user.uid);
      fetchCoordinates(); // Fetch coordinates from Firestore
      fetchAttendanceRecords(user.uid);
      checkAbsenStatus(user.uid); // Check absen status on mount
    } else {
      router.push({ name: "login" });
    }
  });
});

const toNavigate = (routeName) => {
  router.push({ name: routeName });
  console.log(`Navigating to menu ${routeName}`);
  // Add navigation logic here if needed
};
</script>

<style>
ion-content.home-page {
  --background: #f5f5f3;
}
.main_content_div {
  padding: 0px;
}
.user_div {
  margin-bottom: 10px;
}
.top-radius {
  border-radius: 18px;
}
.content_div {
  padding: 20px;
}
.menu-item {
  text-align: center;
  cursor: pointer;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s;
}
.menu-item:hover {
  background-color: #e0e0e0;
}
.menu-item h6,
.menu-item h5 {
  margin: 0;
  font-size: 1.2rem;
  color: #fff;
}
.item-menu {
  text-align: center;
  cursor: pointer;
}
.item-menu img {
  width: 100%;
  height: auto;
  border-radius: 8px;
}
.absen-buttons {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 20px;
}
</style>
